// theme.js — gestion du thème clair/sombre (Design System GoWele).
// Source de vérité : localStorage 'gowele_theme' ('light' | 'dark') ; à défaut, préférence système.
const KEY = 'gowele_theme';

export const getPreferredTheme = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (_) { /* stockage indisponible */ }
  const prefersDark = typeof window !== 'undefined' && window.matchMedia
    && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'dark' : 'light';
};

export const applyTheme = (theme) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
};

export const setTheme = (theme) => {
  try { localStorage.setItem(KEY, theme); } catch (_) { /* ignore */ }
  applyTheme(theme);
};

// Applique le thème AU PLUS TÔT (appelé depuis index.js avant le rendu) → aucun flash.
export const initTheme = () => applyTheme(getPreferredTheme());
